import * as yup from 'yup';
import { test5erSteps } from '@/features/Sparten/pkv/schema/schema';

const pflegezusatzFelder = [5, 15, 35, 45, 55].reduce(
  (acc, value, index) => ({
    ...acc,
    [`grad${index + 1}`]: yup
      .number()
      .max(80)
      .default(value)
      .test('stepTest', 'Eingabe nur in Fünferschritten', (val) =>
        test5erSteps(val),
      ),
  }),
  {},
);

export const pflegetagegeldOptionenSchema = yup.object({
  ...pflegezusatzFelder,
  pflegekostenTarife: yup.boolean().default(true),
  pflegeBahrTarife: yup.boolean().default(false),
  pflegeBahrAufbauTarife: yup.boolean().default(false),
});
